module.exports = __webpack_public_path__ + "static/media/python.b9bbb1d7.png";